const colors = {
  pending: 'amber',
  fulfilled: 'blue',
  cancel: 'red darken-2',
  notAvailable: 'grey',
}

export default colors
